import { render } from "./ProjectGeneralComponent.vue?vue&type=template&id=577f08ec"
import script from "./ProjectGeneralComponent.vue?vue&type=script&lang=js"
export * from "./ProjectGeneralComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__